import { Outlet } from "react-router-dom";
import { AppNavigation } from "@/components/navigation/app-navigation";
import { AppFooter } from "@/components/layout/AppFooter";

export default function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <AppNavigation />
      <main className="flex-1">
        <Outlet />
      </main>
      <AppFooter />
    </div>
  );
}
